module.exports = __webpack_public_path__ + "6a8f3a4bcfc3045600a6d6b2efa2404e.svg";